import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import vue from "../../../../../../../../adapter-vue";
  import BottomPopup from "../../../../../../../common/BottomPopup";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'form-popup',
  props: {
    show: { type: Boolean, default: false },
    title: { default: "" }
  },
  emits: ["onClose", "onSubmit"],
  setup(__props: any, { emit: __emit }) {

  const { withDefaults, defineProps, defineEmits } = vue;
  const props = __props;
  const emits = __emit;
  function onClose() {
    emits("onClose");
  }
  function onSubmit() {
    emits("onSubmit");
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BottomPopup), {
    class: "form-item-bottom-popup",
    show: props.show,
    title: props.title,
    borderRadius: "20px",
    onOnClose: onClose,
    onOnSubmit: onSubmit
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["show", "title"]))
}
}

})